export const INSTALL_NEXT_CHECK_STORAGE_KEY = "aquo/install-next-check";

export const updatePrimaryThemeColor = (color: string) => requestAnimationFrame(() => {
  // @todo Extend window for themeColor node
  // @ts-ignore
  window.themeColor.content = color;
  document.body.style.backgroundColor = color;
});

export const isServer = () => typeof window === "undefined";

export const getUserAgent = () => {
  if (isServer()) {
    return "";
  }

  return window.navigator.userAgent.toLowerCase();
};

export const getLocationQueryParams = () => {
  if (isServer()) {
    return {};
  }

  return Object.fromEntries(new URLSearchParams(window.location.search));
};

export const isIOS = () => /iphone|ipad|ipod/.test(getUserAgent());

export const isInStandaloneMode = () => {
  if (getLocationQueryParams().source === "pwa") {
    return true;
  }

  if (typeof window === "undefined") {
    return true;
  }

  if (window.matchMedia("(display-mode: standalone)").matches) {
    return true;
  }

  // @ts-ignore
  if (window.navigator.standalone === true) {
    return true;
  }

  return false;
};

export const getNumberValueFromStorage = (key: string): number => {
  if (isServer()) {
    return 0;
  }

  if ("localStorage" in window) {
    return parseInt(window.localStorage?.getItem(key) || "0", 10);
  }

  return 0;
};

export const saveNumberValueToStorage = (key: string, value: number): void => {
  if (isServer()) {
    return;
  }

  if ("localStorage" in window) {
    return window.localStorage?.setItem(key, value.toString());
  }
};

export const getNextCheckTimestamp = () => {
  return getNumberValueFromStorage(INSTALL_NEXT_CHECK_STORAGE_KEY);
};

export const setNextCheckTimestamp = (value: number) => {
  return saveNumberValueToStorage(INSTALL_NEXT_CHECK_STORAGE_KEY, value);
};